import { defineStore } from "pinia";
import Swal from "sweetalert2";

export const useSharedStore = defineStore("Shared", {
  state: () => ({
    loading: false,
    pendingRequests: 0,
  }),
  actions: {
    startRequest() {
      this.pendingRequests++;
      this.loading = true;
    },
    endRequest() {
      this.pendingRequests--;
      if (this.pendingRequests <= 0) {
        this.pendingRequests = 0;
        this.loading = false;
      }
    },
    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: message,
        timer: 3000,
        showConfirmButton: false,
      });
    },
    showError(message, detail = null) {
      let resolvedMessage = message;
      if (
        resolvedMessage &&
        typeof resolvedMessage === "object" &&
        !Array.isArray(resolvedMessage)
      ) {
        resolvedMessage =
          resolvedMessage.error ||
          resolvedMessage.message ||
          resolvedMessage.detail ||
          JSON.stringify(resolvedMessage);
      }

      if (detail) {
        let detailText = "";
        if (typeof detail === "string") {
          detailText = detail;
        } else if (detail.response?.data) {
          const d = detail.response.data;
          detailText =
            typeof d === "string"
              ? d
              : d.error || d.message || d.detail || JSON.stringify(d);
        } else if (detail.message) {
          detailText = detail.message;
        }
        if (
          detailText &&
          typeof resolvedMessage === "string" &&
          !resolvedMessage.includes(detailText)
        ) {
          resolvedMessage = `${resolvedMessage}\n${detailText}`;
        }
      }

      let isList = false;
      let listItems = [];

      if (Array.isArray(resolvedMessage)) {
        isList = true;
        listItems = resolvedMessage.filter(Boolean);
      } else if (
        typeof resolvedMessage === "string" &&
        resolvedMessage.includes("\n")
      ) {
        const lines = resolvedMessage
          .split("\n")
          .map((l) => l.trim())
          .filter(Boolean);
        if (lines.length > 1) {
          isList = true;
          listItems = lines;
        }
      }

      if (isList && listItems.length > 0) {
        const htmlContent = `
          <ul style="text-align: left; padding-left: 20px; margin: 10px 0 0 0; line-height: 1.6; font-size: 0.95rem;">
            ${listItems.map((item) => `<li style="margin-bottom: 4px;">${item}</li>`).join("")}
          </ul>
        `;
        Swal.fire({
          icon: "error",
          title: "Validasi Gagal",
          html: htmlContent,
          showConfirmButton: true,
          confirmButtonText: "Tutup",
          confirmButtonColor: "#d33",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: resolvedMessage || "Terjadi kesalahan.",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    formatTanggal(isoString) {
      if (!isoString) return "-";
      const date = new Date(isoString);
      const options = { day: "2-digit", month: "long", year: "numeric" };
      return date.toLocaleDateString("id-ID", options);
    },
  },
});
